import { mergeStyles } from '@fluentui/react';

import { theme } from '../utils/theme';

type ContentBoxProps = {
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export default (props: ContentBoxProps) => {
  return (
    <div className={contentBoxStyles} style={props.style}>
      {props.children}
    </div>
  );
};

const contentBoxStyles = mergeStyles({
  padding: "1rem",
  boxShadow: theme.effects.elevation4,
  backgroundColor: "white",
});
